import styled from 'styled-components';
import React from 'react';
import { ResizerProps } from './types';

const StyledResizer = styled.div`
    position: absolute;
    width: 5px;
    right: 0;
    height: 100%;
    cursor: col-resize;
    transition: background-color 200ms ease-in-out;
    &:hover {
        background-color: var(--minor-accent__enabled__fill__hovered);
    }
`;

const Resizing = styled(StyledResizer)`
    cursor: default;
`;

export const Resizer = React.forwardRef<HTMLDivElement, ResizerProps>(
    ({ onResize, onResetSize, resizing, ...rest }, ref) => {
        return resizing ? (
            <Resizing
                ref={ref}
                {...rest}
                onDoubleClick={onResetSize}
                onMouseDownCapture={onResize}
            />
        ) : (
            <StyledResizer
                ref={ref}
                {...rest}
                onMouseDownCapture={onResize}
                onDoubleClick={onResetSize}
            />
        );
    },
);

Resizer.displayName = 'Resizer';
